<script setup lang="ts">
import {inject} from "vue";
import type {IntlService} from "@progress/kendo-vue-intl";
import {useUxData} from "@/stores/ux-data";

const props = defineProps<{
  start: number | null | undefined,
  end: number | null | undefined,
  total: number | null | undefined,
  disablePrevious: boolean | undefined,
  disableNext: boolean | undefined,
  // The list these pages belong to is being replaced: a fetch is out for it.
  loading?: boolean,
}>()
const emit = defineEmits(['next','previous'])
const ux = useUxData();
const kendo: IntlService = inject('kendo') as IntlService

// The pager waits for a fetch in flight. A page url carries the query of the fetch that produced
// it, so until the new list lands the links still belong to the previous one: paging then would
// show the old filter's next page under the new filter's chips. The click is ignored rather than
// the buttons disabled — a button that turns disabled while it has focus hands the focus to
// <body>, and a keyboard user would lose their place on every page turn.
const onNextClick = (event: any) => {
  if (!props.loading) emit('next', event)
}

const onPreviousClick = (event: any) => {
  if (!props.loading) emit('previous', event)
}
</script>

<template>
  <div v-if="props.start && props.end" class="metadata d-block">
    {{ kendo.format("{0:n0}-{1:n0} of {2:n0}", props.start ?? '#', props.end ?? '#', props.total ?? 0) }}
  </div>
  <div class="btn-group">
    <button
        type="button"
        class="btn btn-sm btn-light"
        :disabled="disablePrevious"
        @click="onPreviousClick"
    >
      <span class="fa-light fa-caret-left"></span>
      <span class="sr-only">{{ ux.labels.actions.previous }}</span>
    </button>
    <button
        type="button"
        class="btn btn-sm btn-light"
        :disabled="disableNext"
        @click="onNextClick"
    >
      <span class="fa-light fa-caret-right"></span>
      <span class="sr-only">{{ ux.labels.actions.next }}</span>
    </button>
  </div>
</template>
